<script>
	import Router from 'svelte-spa-router'
	import routes from './routes.js'
    import Header from './Header.svelte';
    import Footer from './Footer.svelte';
</script>


<main>
	<div class="opacity-0">
		<Header />
	</div>
	<div class="h-100">
		<Router {routes} />
	</div>
	<div class="opacity-0">
		<Footer />
	</div>
	<div class="fixed-header position-fixed w-100 top-0">
		<Header />
	</div>
	<div class="position-fixed w-100 bottom-0">
		<Footer />
	</div>
</main>


<style>
    .fixed-header{
        border-bottom: 6px solid #87af20;
		background: #FFFFFFDF;
    }
</style>